// frontend/geopolitikia/src/components/LeftPanel.jsx
import React, { useMemo } from 'react';
import {
  Crown,
  HandCoins,
  Shield,
  Laptop,
  Users,
  Handshake,
  Leaf,
  Scale,
  Radiation,
} from "lucide-react";
import StatCard from "./StatCard";
import Climate from "./Climate";
import Boutton from "./Button.jsx";

const LeftPanel = ({ gameState, impactsByParam, handleInvest, pendingInvestments, canInvest, popin, stat, nucleaire, redBtn, nuclearValue, hasImpactNucl, impactNucl }) => {

  const groupImpactsByParam = (impacts) => {
    const grouped = {};
    impacts.forEach((impact) => {
      if (!grouped[impact.param]) {
        grouped[impact.param] = [];
      }
      grouped[impact.param].push(impact);
    });
    return grouped;
  };

  const memoizedImpactsByParam = useMemo(() => {
    if (!gameState || !gameState.impacts) return {};
    return groupImpactsByParam(gameState.impacts);
  }, [gameState]);

  // Early return if gameState or joueur is not available
  if (!gameState || !gameState.joueur) {
    return (
      <aside className="left-panel">
        <div className="country-info">
          <div className="country-title">
            <span>Loading...</span>
          </div>
        </div>
      </aside>
    );
  }

  return (
    <aside className="left-panel">
      <div className="country-info">
        <div className="country-title">
          <span>{gameState.joueur.name}</span>
        </div>
        <div className="leader-info">
          <strong><Crown size={16} className="inline-icon" /> Leader :</strong>
          <span>{gameState.joueur.leader}</span>
        </div>
        <div className="stats-grid">
          <StatCard
            label="Économie"
            color="economy"
            icon={<HandCoins size={20} color="#facc15" />}
            value={gameState.joueur.economy}
            previousValue={impactsByParam.economy?.length > 0 ? gameState.joueur.economy - impactsByParam.economy[0].impact : undefined}
            impact={impactsByParam.economy?.[0]?.impact}
            onInvest={handleInvest}
            isSelected={pendingInvestments.includes("Économie")}
            isInvestDisabled={!canInvest && !pendingInvestments.includes("Économie")}
          />
          <StatCard
            label="Militaire"
            color="military"
            icon={<Shield size={20} color="#ef4444" />}
            value={gameState.joueur.military}
            previousValue={impactsByParam.military?.length > 0 ? gameState.joueur.military - impactsByParam.military[0].impact : undefined}
            impact={impactsByParam.military?.[0]?.impact}
            onInvest={handleInvest}
            isSelected={pendingInvestments.includes("Militaire")}
            isInvestDisabled={!canInvest && !pendingInvestments.includes("Militaire")}
          />
          <StatCard
            label="Technologie"
            color="technology"
            icon={<Laptop size={20} color="#3b82f6" />}
            value={gameState.joueur.technology}
            previousValue={impactsByParam.technology?.length > 0 ? gameState.joueur.technology - impactsByParam.technology[0].impact : undefined}
            impact={impactsByParam.technology?.[0]?.impact}
            onInvest={handleInvest}
            isSelected={pendingInvestments.includes("Technologie")}
            isInvestDisabled={!canInvest && !pendingInvestments.includes("Technologie")}
          />
          <StatCard
            label="Population"
            color="population"
            icon={<Users size={20} color="#8b5cf6" />}
            value={gameState.joueur.population}
            previousValue={impactsByParam.population?.length > 0 ? gameState.joueur.population - impactsByParam.population[0].impact : undefined}
            impact={impactsByParam.population?.[0]?.impact}
          />
          <StatCard
            label="Diplomatie"
            color="diplomacy"
            icon={<Handshake size={20} color="#ffffff" />}
            value={gameState.joueur.diplomacy}
            previousValue={impactsByParam.diplomacy?.length > 0 ? gameState.joueur.diplomacy - impactsByParam.diplomacy[0].impact : undefined}
            impact={impactsByParam.diplomacy?.[0]?.impact}
            onInvest={handleInvest}
            isSelected={pendingInvestments.includes("Diplomatie")}
            isInvestDisabled={!canInvest && !pendingInvestments.includes("Diplomatie")}
          />
          <StatCard
            label="Ressources"
            color="resources"
            icon={<Leaf size={20} color="#22c55e" />}
            value={gameState.joueur.natural_resources}
            previousValue={impactsByParam.natural_resources?.length > 0 ? gameState.joueur.natural_resources - impactsByParam.natural_resources[0].impact : undefined}
            impact={impactsByParam.natural_resources?.[0]?.impact}
            onInvest={handleInvest}
            isSelected={pendingInvestments.includes("Ressources")}
            isInvestDisabled={!canInvest && !pendingInvestments.includes("Ressources")}
          />
          <StatCard
            label="Stabilité"
            color="stability"
            icon={<Scale size={20} color="#000000" />}
            value={gameState.joueur.stability}
            previousValue={impactsByParam.stability?.length > 0 ? gameState.joueur.stability - impactsByParam.stability[0].impact : undefined}
            impact={impactsByParam.stability?.[0]?.impact}
            onInvest={handleInvest}
            isSelected={pendingInvestments.includes("Stabilité")}
            isInvestDisabled={!canInvest && !pendingInvestments.includes("Stabilité")}
          />
          <div
            className={`stat-card nuclear ${!canInvest && !pendingInvestments.includes("Nucléaire") ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:scale-105 transition-transform duration-300'}`}
            onClick={() => (canInvest || pendingInvestments.includes("Nucléaire")) && handleInvest("Nucléaire")}
            title={canInvest || pendingInvestments.includes("Nucléaire") ? "Investir dans le nucléaire" : ''}
          >
            <div className="stat-label">
              {redBtn ? (
                <>
                  <button
                    className="nuclear-button"
                    title="Déclencher l'arme nucléaire"
                    onClick={(e) => { e.stopPropagation(); nucleaire(); }}
                  >
                    <svg viewBox="0 0 512 512" width="24" height="24">
                      <g>
                        <path className="st0" d="M256.04,273.772c6.625,0,13.219-1.766,19.016-5.109c18.156-10.5,24.406-33.828,13.922-52.031
                                      c-6.781-11.75-19.438-19.031-33.016-19.031c-6.656,0-13.219,1.766-19.016,5.109c-18.172,10.516-24.438,33.828-13.922,52.031
                                      C229.805,266.475,242.461,273.772,256.04,273.772z"></path>
                        <path className="st0" d="M296.633,306.084c-3.625-6.297-11.328-8.891-18.031-6.109c0,0,1.031,0.391-4.734,1.969
                                      c-5.766,1.563-11.781,2.375-17.875,2.375c-6.109,0-12.094-0.813-17.875-2.375c-5.766-1.578-4.719-1.969-4.719-1.969
                                      c-6.703-2.781-14.438-0.188-18.031,6.109l-80.156,138.812c-2,3.469-2.484,7.609-1.313,11.438c1.188,3.828,3.891,6.984,7.516,8.75
                                      c0,0,7.219,4.438,18.297,8.891c30.484,12.297,63.234,18.703,96.281,18.766c33.063-0.063,65.781-6.469,96.297-18.766
                                      c11.078-4.453,18.297-8.891,18.297-8.891c3.594-1.766,6.328-4.922,7.5-8.75s0.688-7.969-1.297-11.438L296.633,306.084z"></path>
                        <path className="st0" d="M510.508,199.928c-4.594-32.563-15.422-64.125-31.906-92.781c-16.547-28.609-38.469-53.719-64.375-74.016
                                      c-9.422-7.344-16.875-11.391-16.875-11.391c-3.281-2.25-7.391-3.016-11.328-2.109c-3.906,0.891-7.25,3.375-9.266,6.844
                                      l-80.125,138.813c-3.625,6.266-2.016,14.266,3.734,18.672c0,0-0.188-1.109,4.078,3.109c4.203,4.219,7.938,9.016,11,14.281
                                      c3.031,5.313,5.328,10.906,6.859,16.672c1.531,5.797,0.672,5.078,0.672,5.078c0.938,7.203,7.031,12.594,14.313,12.594H497.57
                                      c4,0,7.828-1.672,10.563-4.609s4.109-6.875,3.828-10.859C511.961,220.225,512.195,211.741,510.508,199.928z"></path>
                        <path className="st0" d="M189.024,223.1c0,0-0.859,0.719,0.672-5.078c1.531-5.766,3.797-11.359,6.859-16.672
                                      c3.063-5.281,6.766-10.063,11-14.281s4.063-3.109,4.063-3.109c5.766-4.406,7.375-12.406,3.75-18.672L135.211,26.475
                                      c-2-3.469-5.359-5.953-9.266-6.844c-3.906-0.906-8.016-0.141-11.328,2.109c0,0-7.453,4.047-16.844,11.391
                                      c-25.906,20.297-47.828,45.406-64.406,74.016c-16.469,28.656-27.281,60.219-31.906,92.781c-1.656,11.813-1.422,20.297-1.422,20.297
                                      c-0.281,3.984,1.063,7.922,3.828,10.859c2.719,2.938,6.547,4.609,10.563,4.609h160.281
                                      C181.977,235.694,188.086,230.303,189.024,223.1z"></path>
                      </g>
                    </svg>
                  </button>
                </>
              ) : (<Radiation size={20} className="inline-icon" color="#00ff1a" />)}
              Nucléaire
            </div>
            <div className="stat-value">{hasImpactNucl ? (
              <>
                <span>{nuclearValue - impactNucl}</span>
                <span className="stat-arrow">→</span>
                <span style={{ color: impactNucl >= 0 ? "#4caf50" : "#f44336", fontWeight: "bold" }}>
                  {nuclearValue}
                </span>
              </>
            ) : (
              <span>{nuclearValue}</span>
            )}
              {typeof handleInvest === 'function' && (
                <div
                  className={`relative ml-2 p-2 rounded-full transition-all duration-300 transform group overflow-hidden
                          ${pendingInvestments.includes("Nucléaire")
                      ? 'bg-green-500 shadow-green-500/50'
                      : 'bg-gradient-to-r from-yellow-500 to-amber-500 shadow-yellow-500/50'
                    }
                          ${!canInvest && !pendingInvestments.includes("Nucléaire") ? 'opacity-50' : ''
                    }`}
                >
                  <HandCoins size={16} className="text-black" />
                </div>
              )}
            </div>
          </div>
        </div>
        {gameState.climate && gameState.climate.degree !== undefined && gameState.climate.ocean !== undefined && (
          <Climate
            climate={gameState.climate}
            year={gameState.year}
          />
        )}
      </div>
      <div className="old-news">
        <div></div>
        <Boutton
          text="NEWSPAPER"
          onClick={popin}
          text_after="IA_PAPER"
          delay={0}
          variant="yellow"
        />
        <div></div>
        <div></div>
        <Boutton
          text="STATS"
          onClick={stat}
          text_after="📈📊"
          delay={0}
          variant="yellow"
        />
        <div></div>
      </div>
    </aside>
  );
};

export default React.memo(LeftPanel);